"use strict";
const axios = require("axios");

const endpoint = process.env.REACT_APP_REST_ENDPOINT;
const apikey = process.env.REACT_APP_REST_APIKEY;


export const checkEmail = async (email) => {
  let data = JSON.stringify({
    email: email,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/checkemail",
    headers: {
   //   "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { available: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const verify = async (user, code) => {
  let data = JSON.stringify({
    user: user,
    code: code,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/verify",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const forgotPassword = async (email) => {
  let data = JSON.stringify({
    email: email,
  });

  const options = {
    method: "POST",
    // url: "https://pfmahqr4ik.execute-api.us-east-1.amazonaws.com/prod/forgot",
    url: endpoint + "auth/forgot",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false, data: "" };

  try {
    const res = await axios.request(options);

    if (res.data.success) {
      response = { success: true, data: res.data };
    } else {
      response = { success: false, data: res.data.message };
    }
  } catch (error) {
    response = { success: false, data: error.response.data.message };
    console.error(error);
  }

  return response;
};

export const changePassword = async (
  email,
  token,
  oldPassword,
  newPassword
) => {
  let data = JSON.stringify({
    user: email,
    token: token,
    oldpassword: oldPassword,
    newpassword: newPassword,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/password",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const resetPassword = async (email, code, confirmPassword) => {
  let data = JSON.stringify({
    user: email,
    confirmationCode: code,
    newPassword: confirmPassword,
  });

  const options = {
    method: "POST",
    url: endpoint + "auth/reset",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    response.error = true;
    console.error(error);
  }

  return response;
};

export const addUser = async ({
  email,
  firstname,
  lastname,
  username,
  phone,
  password,
}) => {
  
  let data = {
    email: email,
    firstname: firstname,
    lastname: lastname,
    username: username,
    phone: phone,
    password: password,
  };
  const options = {
    method: "POST",
    url: endpoint + "auth/submit",
    headers: {
      // "x-api-key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = {};

  try {
    const res = await axios.request(options);
    response = res.data;
  } catch (error) {
    console.error(error);
  }

  return response;
};
export const migrateUser = async ({ username, password, token }) => {
  let data = JSON.stringify({
    username: username,
    password: password,
    token: token,
  });

  const options = {
    method: "POST",
    // url: `${process.env.REACT_APP_MIGRATE_ENDPOINT}`,
    url: endpoint + "auth/migrate",
    headers: {
      "x-api-key": process.env.REACT_APP_MIGRATION_KEY,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false };

  try {
    const res = await axios.request(options);
    response = {
      success: true,
      data: res.data,
      idToken: res.data.idToken,
      accessToken: res.data.accessToken,
      refreshToken: res.data.refreshToken,
      username: res.data.username || username,
    };
  } catch (error) {
    response.error = true;
    console.error("Migration error:", error);
    if (error.response) {
      response.message = error.response.data?.message || `Migration failed with status ${error.response.status}`;
      response.status = error.response.status;
    } else if (error.request) {
      response.message = "Network error - unable to reach migration endpoint";
    } else {
      response.message = error.message || "Unknown migration error";
    }
  }

  return response;
};

const TIMEFRAME_MAP = {
  Daily: "D",
  Weekly: "W",
  Monthly: "M",
  Annually: "Y"
};

export const fetchStrategiesForPeriod = async (period, page = 1, pageSize = 12) => {
  let data = JSON.stringify({
    period: TIMEFRAME_MAP[period],
    page,
    pageSize,
  });

  const options = {
    method: "POST",
    url: endpoint + "perf_slices",
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = {
    success: false,
    data: [],
    pagination: {
      page,
      pageSize,
      total: 0,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };

  try {
    const res = await axios.request(options);
    const pagination = res.data?.pagination || {};

    response = {
      success: true,
      data: Array.isArray(res.data) ? res.data : res.data?.data || [],
      pagination: {
        page: pagination.page || page,
        pageSize: pagination.pageSize || pageSize,
        total: pagination.total || 0,
        totalPages: pagination.totalPages || 1,
        hasNextPage: Boolean(pagination.hasNextPage),
        hasPrevPage: Boolean(pagination.hasPrevPage),
      },
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load strategies";
    console.error(error);
  }

  return response;
};

export const fetchAnnualPerformance = async (strategyId, startYear = 2023) => {
  let data = JSON.stringify({
    startYear: startYear,
  });

  const options = {
    method: "POST",
    url: `${endpoint}annual_performance?strategyId=${strategyId}`,
    headers: {
      "X-Api-Key": apikey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  let response = { success: false, data: null };

  try {
    const res = await axios.request(options);
    response = {
      success: true,
      data: res.data,
    };
  } catch (error) {
    response.error = true;
    response.message = error?.message || "Failed to load annual performance";
    console.error(error);
  }

  return response;
};
